import React from 'react';
import { getLabel } from '../../../InitData';
import { getConfiguration, oddToStringCheckbet } from '../../../data/utils';
import EventInfo from './EventInfo';
import { WidgetContext, useWidgetContext } from '../../widgets/WidgetContext';
import ScoreAndTime from './ScoreAndTime';
import { xs_isMobile } from '../../..';
import LiveTrackerToggle from './LiveTrackerToggle';
import LiveTracker from './LiveTracker';

const getEsitoClass = function(eventStatus, winning, winningDrawCode) {
	if(eventStatus === 'voided'){
   		return 'esito-vd';
   	}
	if (!['winning', 'losing'].includes(eventStatus) || !winningDrawCode) {
	    return 'esito-nd';
	}
    return winning ? 'esito-v' : 'esito-p';
}

function getUrl(event) {
    const conf = getConfiguration();
    let url = null;

    try {
        const routes = window.appConfig.ROUTES;
        const prematchPath = conf.xspu?.pm;
        const livePath =  conf.xspu?.lv;

        if (event.state === 'in_progress') {
            if (xs_isMobile) {
                url = `https://${conf.url}${livePath||routes.live.live}`;
            } else {
                url = `https://${conf.url}${livePath||routes.live['live-suite']}`;
            }
        } else {
            if (xs_isMobile) {
                url = `https://${conf.url}${prematchPath||routes.prematch.prematch}/_${event.sportRef}_${event.categoryRef}_${event.tournamentRef}`;
            } else {
                url = `https://${conf.url}${prematchPath||routes.prematch['top-match']}/_${event.sportRef}_${event.categoryRef}_${event.tournamentRef}`;
            }
        }
    }catch(err) {
        console.error(err);
    }
    
    return url;
}

function EventsList(props) {
    const conf = getConfiguration();
    const [widgetContext] = useWidgetContext('#br_widget');
    const isV3 = conf.mbt === 'V3';
    
    return (
        <WidgetContext.Provider value={widgetContext}>
            <div className="grey-box bold | mb_6_1">
                <div className="mb_6_1_1">
                    <div className="d-flex align-items-center justify-content-center text-medium uppercase desc-event-checkbet | mb_6_1_1_1">
                        Evento
                    </div> 
                </div>
                <div className="mb_6_1_2">
                    <div className="inner-grid | mb_6_1_2_1">
                        <span className="text-medium | mb_6_1_2_1_1">{getLabel('mybets.segno', 'Segno')}</span>
                        {!props.isBetBuilder && <span className="text-medium | mb_6_1_2_1_2">{getLabel('mybets.quota')}</span>}
                        <span className="text-medium | mb_6_1_2_1_3">{getLabel('mybets.esito', 'Esito')}</span>
                    </div>
                    <div className="mb_6_1_2_1"></div>
                </div>
            </div>
            {props.events.map((event, i) => {
                return (
                    <React.Fragment key={`${event.id}_${i}`}>
                        <EventItem event={event} isCheckbet={props.isCheckbet} >
                            <div className="d-flex flex-column margine-su-giu | mb_10_1">
                                <EventInfo isPsv={props.isPsv} event={event} isSystem={props.isSystem} />
                                <div className="mb_10_2">
                                    <div className="d-flex align-items-center text-medium bold desc-event-checkbet | mb_10_2_1">
                                        {event.desc}
                                        {event.score?.length > 0 &&
                                            <span className="mb_10_2_1_1">{event.score.replace(':', ' - ')}</span>
                                        }
                                        {props.isSystem && !event.var &&
                                            <span className="ml-auto mr-2 bold | mb_10_2_1_2">F</span>
                                        }
                                    </div>
                                    <ScoreAndTime {...event} />
                                    {conf.fomb && !isV3 &&
                                        <LiveTrackerToggle event={event} />
                                    }
                                </div>
                                <LiveTracker event={event} />
                                {event.bets.map((bet,i) => {
                                    return (
                                        <div key={`${bet.id}_${bet.drawCode}_${i}`} className="grey-box | mb_10_3">
                                            <div className="mb_10_3_1">
                                                <div className="flex | mb_10_3_1_1">
                                                    {conf.fomb && isV3 &&
                                                        <LiveTrackerToggle event={event} />
                                                    }
                                                    <span className="text-medium | mb_10_3_1_1_1">{bet.desc}</span>
                                                </div>
                                            </div>
                                            <div className="mb_10_3_2">
                                                <div className="inner-grid | mb_10_3_2_1">
                                                    <span className="text-medium bold | mb_10_3_2_1_1">{bet.drawDesc}</span>
                                                    {!props.isBetBuilder ?
                                                        <div className="d-flex | mb_10_3_2_1_2">
                                                            <span className="text-medium bold | mb_10_3_2_1_2_1">{oddToStringCheckbet(bet.odd)}</span>  
                                                        </div>
                                                        :
                                                        <div className="mb_10_3_2_1_3"></div>
                                                    }
                                                    <span className={"esito | mb_10_3_2_1_3 " + getEsitoClass(event.state, bet.isWinning, bet.winningDrawCode)}></span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </EventItem>
                    </React.Fragment>
                );
			})}
        </WidgetContext.Provider>
    );
}

function EventItem(props) {
    return (
        <>
            {window.appConfig?.XSHOP_TERMINAL || props.isCheckbet ?
                <div className="event d-flex flex-column | mb_10">{props.children} </div>
                :
                <a href={getUrl(props.event)} target="_blank" rel="noreferrer" className="event d-flex flex-column | mb_10">{props.children}</a>
            }
        </>
    );
}

export default EventsList;